import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/layout/Layout';
import { SimplifiedDashboard } from './pages/SimplifiedDashboard';
import { SimplifiedKnowledgeBase } from './pages/SimplifiedKnowledgeBase';
import { RegistrationRPA } from './pages/RegistrationRPA';
import Patients from './pages/Patients';
import Settings from './pages/Settings';
import Login from './pages/Login';
// Protected Route Component
function ProtectedRoute({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  if (isLoading) {
    return <div className="flex items-center justify-center h-screen" data-id="element-0">
        <div className="text-center" data-id="element-1">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black mx-auto mb-4" data-id="element-2"></div>
          <p className="text-gray-600" data-id="element-3">Loading...</p>
        </div>
      </div>;
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace data-id="element-4" />;
  }
  return <>{children}</>;
}
function AppRoutes() {
  const {
    isAuthenticated
  } = useAuth();
  return <Routes data-id="element-5">
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" replace data-id="element-7" /> : <Login data-id="element-8" />} data-id="element-6" />
      <Route path="/" element={<ProtectedRoute data-id="element-10">
            <Layout simplified data-id="element-11" />
          </ProtectedRoute>} data-id="element-9">
        <Route index element={<SimplifiedDashboard data-id="element-13" />} data-id="element-12" />
        <Route path="patients" element={<Patients data-id="element-15" />} data-id="element-14" />
        <Route path="knowledge-base" element={<SimplifiedKnowledgeBase data-id="element-17" />} data-id="element-16" />
        <Route path="data-agent" element={<RegistrationRPA data-id="element-19" />} data-id="element-18" />
        <Route path="settings" element={<Settings data-id="element-21" />} data-id="element-20" />
      </Route>
    </Routes>;
}
export function App() {
  return <AuthProvider data-id="element-22">
      <Router data-id="element-23">
        <AppRoutes data-id="element-24" />
      </Router>
    </AuthProvider>;
}